import * as React from "react";
import PropTypes from "prop-types";
import { AppBar } from "@mui/material";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
const drawerWidth = 240;
const navItems = [
  { title: "HOME", href: "/" },
  { title: "ABOUT US", href: "/#about" },
  { title: "RECENT DESIGNS", href: "/#recent-designs" },
  { title: "TESTOMONAIL", href: "/#testimonial" },
];

function DrawerAppBar(props) {
  const redirect = useNavigate();
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: "center" }}>
      <Typography variant="h6" sx={{ my: 2, mt: 5 }}>
        <img src={""} style={{ width: "139px", height: "30px" }} alt="logo" />
      </Typography>
      <Divider />
      <List>
        {navItems.map((item) => (
          <ListItem key={item.title} disablePadding>
            <ListItemButton
              sx={{ textAlign: "center" }}
              onClick={() => redirect(item.href)}
            >
              <ListItemText primary={item.title} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />
      <Button
        onClick={() => redirect("/generate")}
        sx={{
          backgroundColor: "white.main",
          color: "blue.main",
          marginTop: "10px",
          "&:hover": {
            color: "yellow.light",
            background: "blue.main",
          },
        }}
      >
        GENERATE YOUR DESIGN
      </Button>
    </Box>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          zIndex: "2",
        }}
      >
        <CssBaseline />
        <AppBar
          component="nav"
          position="static"
          sx={{
            backgroundColor: "transparent",
            borderBottom: "none",
            boxShadow: "none",
          }}
        >
          <Toolbar
            sx={{
              marginX: { lg: "113px", xs: "10px" },
              paddingX: "0px !important",
            }}
          >
            <Typography fontWeight={"bold"} variant="h3">
              T-SHIRT
            </Typography>
            <Box
              sx={{
                display: { lg: "block", xs: "none" },
                marginLeft: "auto",
              }}
            >
              {navItems.map((item) => (
                <Button
                  key={item.title}
                  sx={{
                    color: "white.main",
                    fontStyle: "normal",
                    fontWeight: 600,
                    fontSize: "16px",
                    lineHeight: "20px",
                    textTransform: "uppercase",
                    marginLeft: { xl: "30px", xs: "0px" },
                  }}
                  onClick={() => redirect(item.href)}
                >
                  {item.title}
                </Button>
              ))}

              <Button
                variant="contained"
                onClick={() => redirect("/generate")}
                sx={{
                  color: "blue.main",
                  backgroundColor: "white.main",
                  fontStyle: "normal",
                  fontWeight: 500,
                  fontSize: "18px",
                  lineHeight: "20px",
                  textTransform: "uppercase",
                  marginLeft: { xl: "30px", xs: "10px" },
                  padding: "15px 26px",
                  borderRadius: "42px",
                  "&:hover": {
                    color: "yellow.light",
                    background: "blue.main",
                  },
                }}
              >
                GENERATE YOUR DESIGN
              </Button>
            </Box>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{
                mr: 2,
                display: { lg: "none", sm: "block" },
                marginLeft: "auto",

                padding: "0px",
                color: "white.main",
                width: "50px",
              }}
            >
              <MenuIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <Box
          component="nav"
          sx={{
            display: "flex",
            justifyContent: "end",
          }}
        >
          <Drawer
            container={container}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            anchor="right"
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              display: { lg: "none", sm: "block" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,
                backgroundColor: "blue.main",
                color: "white.main",
              },
            }}
          >
            {drawer}
          </Drawer>
        </Box>
        <Box component="main" sx={{ p: 3 }}>
          <Toolbar />
        </Box>
      </Box>
    </>
  );
}

DrawerAppBar.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default DrawerAppBar;
